export default __webpack_public_path__ + "static/media/workflow.0a1b7329.png";